import { createSelector } from 'reselect'
import config from 'constants/config'
import moment from 'moment'
import { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { sum } from 'lib/array/arrayUtils'
import { checkoutAccommodationOfferView } from 'checkout/selectors/view/accommodation'

interface InteractionStudioData {
  accommodationTotal: number | undefined
  addonsTotal: number
  brand: string
  cartId: string | undefined
  country_code: string | undefined
  currencyCode: string | undefined
  hotelCheckInDate: string
  hotelCheckOutDate: string
  insuranceAccepted: boolean
  insuranceTotal: number
  isFamilyTrip: boolean
  noOfAdults: number
  noOfChildren: number
  noOfInfants: number
  offer_id: string | undefined
  orderCompleted: boolean
  package_id: string | undefined
  platform: string | undefined
  promoCode: null
  promoDiscount: number
  promoId: null
  withFlights: boolean
  reservationType: string | undefined
}

export const getInteractionStudioDataFromOfferPage = createSelector(
  (state: App.State) => state.checkout.cart.cartId,
  (state: App.State) => state.geo?.currentRegionCode,
  (state: App.State) => state.geo?.currentCurrency,
  (state: App.State, offerPageState: OfferPageState) => moment(offerPageState.checkInDate).format('YYYY-MM-DD'),
  (state: App.State, offerPageState: OfferPageState) => moment(offerPageState.checkInDate).add(offerPageState.duration, 'days').format('YYYY-MM-DD'),
  (state: App.State, offerPageState: OfferPageState) => offerPageState.rooms,
  (state: App.State, offerPageState: OfferPageState) => offerPageState.offer?.id,
  (state: App.State, offerPageState: OfferPageState) => offerPageState.offer?.lowestPricePackage?.id,
  (state: App.State) => state.interactionStudio?.platform,
  (state: App.State) => checkoutAccommodationOfferView(state).data[0]?.reservationType,
  (state: App.State, offerPageState: OfferPageState) => offerPageState.offer?.lowestPricePackage?.price,
  (cartId, country_code, currencyCode, checkInDate, checkOutDate, accommodation, offer_id, package_id, platform, reservationType, accommodationTotal): InteractionStudioData => ({
    accommodationTotal,
    addonsTotal: 0,
    brand: config.BRAND,
    cartId,
    country_code,
    currencyCode,
    hotelCheckInDate: checkInDate,
    hotelCheckOutDate: checkOutDate,
    insuranceAccepted: false,
    insuranceTotal: 0,
    isFamilyTrip: accommodation ? !!accommodation[0]?.children || !!accommodation[0]?.infants : false,
    noOfAdults: accommodation ? sum(accommodation.map(occupancy => occupancy.adults)) : 2,
    noOfChildren: accommodation ? sum(accommodation.map(occupancy => occupancy.children)) : 0,
    noOfInfants: accommodation ? sum(accommodation.map(occupancy => occupancy.infants)) : 0,
    offer_id,
    orderCompleted: false,
    package_id,
    platform,
    promoCode: null,
    promoDiscount: 0,
    promoId: null,
    withFlights: false,
    reservationType,
  }),
)
